export default __webpack_public_path__ + "static/media/carousel-pic-two.15481ab5.png";